exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media.form {\n  margin-bottom: 32px; }\n\n.textarea {\n  min-height: 150px; }\n\n.image {\n  overflow: hidden;\n  height: 96px;\n  width: 96px;\n  border-radius: 48px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/forum/forum-form/forum-form.component.scss
// module id = ../../../../../src/app/forum/forum-form/forum-form.component.scss
// module chunks = 1